import { useCountersApi } from "@sundae/react-hooks";
import { useCallback } from "react";
/**
 * Custom hook to handle event tracking using the counters API.
 * This hook wraps the useCountersApi hook, adding a feature flag and a hostname check
 * to conditionally allow or disallow tracking. The tracking is not performed if
 * it's not enabled by the feature flag or if the current hostname is "localhost".
 *
 * @returns {Function} - A callback function that accepts options for the useCountersApi
 *                       call and performs the tracking action if the conditions are met.
 *                       The options should match the IUseCountersApiOptions type.
 */
export const useEventTracking = (allowTracking) => {
    const handleCountersApi = useCountersApi();
    const handleEventTracking = useCallback((options) => {
        if (allowTracking) {
            handleCountersApi(options);
        }
    }, [allowTracking]);
    return handleEventTracking;
};
//# sourceMappingURL=useEventTracking.js.map